/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateGuideDraftDto,
  GuideClinicSettingsResponse,
  GuideDraftResponse,
  GuideOccasionsParams,
  GuideOccasionsResponse,
  GuideTipActionDto,
  GuideTipsParams,
  GuideTipsResponse,
  UpdateGuideClinicSettingsDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * فهرست رتبه‌بندی‌شدهٔ پیشنهادهایی که کاربر اجازهٔ انجامشان رو دارد، با رعایت سقف نمایش و وضعیت‌های تعویق و رد.
 * @summary پیشنهادهای من
 */
export const guideTips = (
    params?: GuideTipsParams,
 signal?: AbortSignal
) => {


      return apiClient<GuideTipsResponse>(
      {url: `/api/v1/guide/tips`, method: 'GET',
        params, signal
    },
      );
    }




export const getGuideTipsQueryKey = (params?: GuideTipsParams,) => {
    return [
    `/api/v1/guide/tips`, ...(params ? [params] : [])
    ] as const;
    }


export const getGuideTipsQueryOptions = <TData = Awaited<ReturnType<typeof guideTips>>, TError = void>(params?: GuideTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGuideTipsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof guideTips>>> = ({ signal }) => guideTips(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GuideTipsQueryResult = NonNullable<Awaited<ReturnType<typeof guideTips>>>
export type GuideTipsQueryError = void


export function useGuideTips<TData = Awaited<ReturnType<typeof guideTips>>, TError = void>(
 params: undefined |  GuideTipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideTips>>,
          TError,
          Awaited<ReturnType<typeof guideTips>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideTips<TData = Awaited<ReturnType<typeof guideTips>>, TError = void>(
 params?: GuideTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideTips>>,
          TError,
          Awaited<ReturnType<typeof guideTips>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideTips<TData = Awaited<ReturnType<typeof guideTips>>, TError = void>(
 params?: GuideTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیشنهادهای من
 */

export function useGuideTips<TData = Awaited<ReturnType<typeof guideTips>>, TError = void>(
 params?: GuideTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideTips>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGuideTipsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پذیرفتن، تعویق یک‌روزه یا یک‌هفته‌ای، رد، «به کار ما نمی‌آید»، «انجام شد» یا بازگرداندن. فهرست به‌روزشده برمی‌گردد. در حالت ورود به‌جای کاربر چیزی ذخیره نمی‌شه.
 * @summary اقدام روی یک پیشنهاد
 */
export const guideTipAction = (
    guideTipActionDto: GuideTipActionDto,
 signal?: AbortSignal
) => {


      return apiClient<GuideTipsResponse>(
      {url: `/api/v1/guide/tips/action`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: guideTipActionDto, signal
    },
      );
    }




export const getGuideTipActionMutationKey = () => ['guideTipAction'] as const;

export const getGuideTipActionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideTipAction>>, TError,GuideTipActionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guideTipAction>>, TError,GuideTipActionMutationVariables, TContext> => {

const mutationKey = getGuideTipActionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guideTipAction>>, GuideTipActionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guideTipAction(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuideTipActionMutationResult = NonNullable<Awaited<ReturnType<typeof guideTipAction>>>
    export type GuideTipActionMutationBody = GuideTipActionDto
    export type GuideTipActionMutationError = void
    export type GuideTipActionMutationVariables = {data: GuideTipActionDto}

    /**
 * @summary اقدام روی یک پیشنهاد
 */
export const useGuideTipAction = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideTipAction>>, TError,GuideTipActionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guideTipAction>>,
        TError,
        GuideTipActionMutationVariables,
        TContext
      > => {
      return useMutation(getGuideTipActionMutationOptions(options), queryClient);
    }
    /**
 * از متن و گروه بیماران پیشنهاد، یک پیش‌نویس پیامک گروهی ساخته می‌شه و مسیر ویرایش آن برمی‌گردد. چیزی فرستاده نمی‌شه. اگر همکاری پیش‌تر همین پیش‌نویس رو ساخته باشد، همان برمی‌گردد.
 * @summary ساخت پیش‌نویس پیامک گروهی از یک پیشنهاد
 */
export const guideCreateDraft = (
    createGuideDraftDto: CreateGuideDraftDto,
 signal?: AbortSignal
) => {


      return apiClient<GuideDraftResponse>(
      {url: `/api/v1/guide/tips/draft`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGuideDraftDto, signal
    },
      );
    }




export const getGuideCreateDraftMutationKey = () => ['guideCreateDraft'] as const;

export const getGuideCreateDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideCreateDraft>>, TError,GuideCreateDraftMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guideCreateDraft>>, TError,GuideCreateDraftMutationVariables, TContext> => {

const mutationKey = getGuideCreateDraftMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guideCreateDraft>>, GuideCreateDraftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guideCreateDraft(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuideCreateDraftMutationResult = NonNullable<Awaited<ReturnType<typeof guideCreateDraft>>>
    export type GuideCreateDraftMutationBody = CreateGuideDraftDto
    export type GuideCreateDraftMutationError = void
    export type GuideCreateDraftMutationVariables = {data: CreateGuideDraftDto}

    /**
 * @summary ساخت پیش‌نویس پیامک گروهی از یک پیشنهاد
 */
export const useGuideCreateDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideCreateDraft>>, TError,GuideCreateDraftMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guideCreateDraft>>,
        TError,
        GuideCreateDraftMutationVariables,
        TContext
      > => {
      return useMutation(getGuideCreateDraftMutationOptions(options), queryClient);
    }
    /**
 * مناسبت‌های روزهای آینده با پنجرهٔ مناسب ارسال پیامک، و روزهایی که ارسال پیام تبلیغاتی مناسب نیست (عزاداری و ماه رمضان).
 * @summary تقویم مناسبت‌ها
 */
export const guideOccasions = (
    params?: GuideOccasionsParams,
 signal?: AbortSignal
) => {


      return apiClient<GuideOccasionsResponse>(
      {url: `/api/v1/guide/occasions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGuideOccasionsQueryKey = (params?: GuideOccasionsParams,) => {
    return [
    `/api/v1/guide/occasions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGuideOccasionsQueryOptions = <TData = Awaited<ReturnType<typeof guideOccasions>>, TError = void>(params?: GuideOccasionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGuideOccasionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof guideOccasions>>> = ({ signal }) => guideOccasions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GuideOccasionsQueryResult = NonNullable<Awaited<ReturnType<typeof guideOccasions>>>
export type GuideOccasionsQueryError = void


export function useGuideOccasions<TData = Awaited<ReturnType<typeof guideOccasions>>, TError = void>(
 params: undefined |  GuideOccasionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideOccasions>>,
          TError,
          Awaited<ReturnType<typeof guideOccasions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideOccasions<TData = Awaited<ReturnType<typeof guideOccasions>>, TError = void>(
 params?: GuideOccasionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideOccasions>>,
          TError,
          Awaited<ReturnType<typeof guideOccasions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideOccasions<TData = Awaited<ReturnType<typeof guideOccasions>>, TError = void>(
 params?: GuideOccasionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تقویم مناسبت‌ها
 */

export function useGuideOccasions<TData = Awaited<ReturnType<typeof guideOccasions>>, TError = void>(
 params?: GuideOccasionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideOccasions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGuideOccasionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * روشن یا خاموش بودن پیشنهادها برای همهٔ کارکنان، و پیشنهادهای پنهان‌شده.
 * @summary تنظیمات پیشنهادهای کلینیک
 */
export const guideClinicSettings = (

 signal?: AbortSignal
) => {


      return apiClient<GuideClinicSettingsResponse>(
      {url: `/api/v1/guide/clinic-settings`, method: 'GET', signal
    },
      );
    }




export const getGuideClinicSettingsQueryKey = () => {
    return [
    `/api/v1/guide/clinic-settings`
    ] as const;
    }


export const getGuideClinicSettingsQueryOptions = <TData = Awaited<ReturnType<typeof guideClinicSettings>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGuideClinicSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof guideClinicSettings>>> = ({ signal }) => guideClinicSettings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GuideClinicSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof guideClinicSettings>>>
export type GuideClinicSettingsQueryError = void


export function useGuideClinicSettings<TData = Awaited<ReturnType<typeof guideClinicSettings>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideClinicSettings>>,
          TError,
          Awaited<ReturnType<typeof guideClinicSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideClinicSettings<TData = Awaited<ReturnType<typeof guideClinicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guideClinicSettings>>,
          TError,
          Awaited<ReturnType<typeof guideClinicSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuideClinicSettings<TData = Awaited<ReturnType<typeof guideClinicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تنظیمات پیشنهادهای کلینیک
 */

export function useGuideClinicSettings<TData = Awaited<ReturnType<typeof guideClinicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guideClinicSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGuideClinicSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * خاموش‌کردن پیشنهادها برای همهٔ کارکنان یا پنهان‌کردن پیشنهادهایی که به کار این کلینیک نمی‌آید.
 * @summary ویرایش تنظیمات پیشنهادهای کلینیک
 */
export const guideUpdateClinicSettings = (
    updateGuideClinicSettingsDto: UpdateGuideClinicSettingsDto,
 signal?: AbortSignal
) => {


      return apiClient<GuideClinicSettingsResponse>(
      {url: `/api/v1/guide/clinic-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateGuideClinicSettingsDto, signal
    },
      );
    }




export const getGuideUpdateClinicSettingsMutationKey = () => ['guideUpdateClinicSettings'] as const;

export const getGuideUpdateClinicSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideUpdateClinicSettings>>, TError,GuideUpdateClinicSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guideUpdateClinicSettings>>, TError,GuideUpdateClinicSettingsMutationVariables, TContext> => {

const mutationKey = getGuideUpdateClinicSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guideUpdateClinicSettings>>, GuideUpdateClinicSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guideUpdateClinicSettings(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuideUpdateClinicSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof guideUpdateClinicSettings>>>
    export type GuideUpdateClinicSettingsMutationBody = UpdateGuideClinicSettingsDto
    export type GuideUpdateClinicSettingsMutationError = void
    export type GuideUpdateClinicSettingsMutationVariables = {data: UpdateGuideClinicSettingsDto}

    /**
 * @summary ویرایش تنظیمات پیشنهادهای کلینیک
 */
export const useGuideUpdateClinicSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guideUpdateClinicSettings>>, TError,GuideUpdateClinicSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guideUpdateClinicSettings>>,
        TError,
        GuideUpdateClinicSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getGuideUpdateClinicSettingsMutationOptions(options), queryClient);
    }
